import React from "react";
import { Link } from "react-router-dom";

export default function SkeletonStoryCard() {
  const to = '';
  return (
    <Link to={to} className="story-card">
      <div className="story-card-ring">
        <div className="thumb">
          <img src='/webisodes/assets/images/error_img.webp' alt="sk-skeleton" loading="lazy" />
          <div className="thumb-scrim" />
          
          <div className="meta">
            <div className="title">Loading..</div>
           
          </div>
        </div>
      </div>
    </Link>
  );
}